"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LAYOUT2_TYPE = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _gerenciatdUtils = require("@bit/gerenciatd.utils.common");
var _gerenciatdUnifiedcomponents = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.button"));
var _gerenciatdUnifiedcomponents2 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.price"));
var _gerenciatdUnifiedcomponents3 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.custom-link"));
var _gerenciatdUnifiedcomponents4 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.claim"));
var _gerenciatdUnifiedcomponents5 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.text-info"));
var _gerenciatdUnifiedcomponents6 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.promo-strip-extended"));
var _gerenciatdUnifiedcomponents7 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.modal-atencion-emp"));
var _bannerUtils = require("../../bannerUtils");
require("./Layout2.scss");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const LAYOUT2_TYPE = exports.LAYOUT2_TYPE = {
  FUSION: 'fusion',
  DISTRIBUTIVA: 'distributiva',
  DISTRIBUTIVA_TEXTO: 'distributiva-texto'
};
const Layout2 = props => {
  const finalProps = (0, _gerenciatdUtils.setUpPropsByDevice)(props);
  const {
    components,
    idBanner,
    type,
    SvgIconLoader,
    mainTaggingInfo,
    contentColors,
    contentPosition,
    fullClickable,
    segment,
    Modal,
    tabsOptions
  } = finalProps;
  let button = null;

  /* Tratamiento botón 1 (caso solo 1 CTA) */
  if (components && components['Button-1'] && !components['Button-2']) button = components['Button-1'];else if (components && components['Button-2'] && !components['Button-1']) button = components['Button-2'];else button = null;

  // Tratamiento fondo del banner
  (0, _bannerUtils.generateBgAndProperties)(`${idBanner}image`, components, Layout2);
  const {
    icons
  } = components;
  const {
    bgColor,
    bgIconColor,
    bgPriceColor
  } = contentColors;
  const onClickModal = item => {
    Modal.setModalProps({
      contentPosition: 'right--center',
      opacityLayoutColor: 'black05',
      inSceneEffect: 'faseInLeft',
      outSceneEffect: 'fadeOutRight',
      closeByClickingOutside: true,
      scrollAllowed: false
    });
    Modal.setContent( /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents7.default, {
      Modal: Modal,
      SvgIconLoader: SvgIconLoader,
      tabsOptions: _objectSpread(_objectSpread({}, tabsOptions), {}, {
        tabOptionPreChecked: item.option
      }),
      product: item.product,
      taggingInfo: mainTaggingInfo,
      campaign: item.campaign
    }));
    Modal.show();
  };
  const printButton = button => {
    if (button && (typeof button.isModal == 'undefined' || !button.isModal)) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: `layout2_button-container layout2_button-container--${type}`,
        id: "show-fixed",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, _objectSpread(_objectSpread({}, button), {}, {
          taggingInfo: mainTaggingInfo
        }))
      });
    }
    if (button && button.isModal) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: `layout2_button-container layout2_button-container--${type}`,
        id: "show-fixed",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, _objectSpread(_objectSpread({}, button), {}, {
          link: null,
          taggingInfo: _objectSpread(_objectSpread({}, mainTaggingInfo), {}, {
            componentContent: button.label,
            componentVariation: button.campaign || mainTaggingInfo.componentVariation
          }),
          onClick: () => {
            onClickModal(button);
          }
        }))
      });
    } else return null;
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "banner layout2",
    children: [components['PromoStripExtended-1'] && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "promostrip",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents6.default, {
          components: components['PromoStripExtended-1']
        })
      })
    }), button && button.link && mainTaggingInfo && fullClickable && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents3.default, {
      className: "zIndex-1",
      isBlockElement: true,
      link: button.link,
      target: button.target,
      forceExternal: button.forceExternal,
      taggingInfo: mainTaggingInfo
    }), button && button.link && fullClickable && components && button && button.isModal && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents3.default, {
      className: "zIndex-1",
      isBlockElement: true,
      taggingInfo: _objectSpread(_objectSpread({}, mainTaggingInfo), {}, {
        componentContent: button.label,
        componentVariation: button.campaign || mainTaggingInfo.componentVariation
      }),
      onClick: () => {
        onClickModal(button);
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      id: idBanner,
      className: `layout2_container--principal layout2_direction--${contentPosition}`,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        id: `${idBanner}image`,
        className: `layout2_image layout2_image--${contentPosition}_type--${type}`
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: `layout2_info--${contentPosition}_type--${type} layout2_info--${bgColor}`,
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: `layout2_layout layout2_layout--${type}`,
          children: [components['TextInfo-1'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents5.default, _objectSpread(_objectSpread({}, components['TextInfo-1']), {}, {
            className: "layout2_subtitle textInfo1"
          })), components['TextInfo-2'] && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: `layout2_wrapper layout2_wrapper--${type} layout2_wrapper--${type}_direction--${contentPosition}`,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents5.default, _objectSpread(_objectSpread({}, components['TextInfo-2']), {}, {
              className: `title--${type} textInfo2`
            }))
          }), components['TextInfo-3'] && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "layout2_subClaim",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents5.default, _objectSpread(_objectSpread({}, components['TextInfo-3']), {}, {
              className: "textInfo3"
            }))
          }), icons &&
          /*#__PURE__*/
          //TODO Sustituir props icons por un componente InfoList-n, aÃ±adir testing.
          (0, _jsxRuntime.jsx)("div", {
            className: "layout2_list-icons",
            children: icons.data.map(icon => /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: "layout2_list-icons_marginRight",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(SvgIconLoader, {
                color: icons.color,
                size: icons.size,
                id: icon
              })
            }))
          }), (type !== 'fusion' || components['Price-1'] || components['Price-2']) && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: `layout2_container layout2_container--${type}`,
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: "layout2_container_saving",
              children: components['Claim-1'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents4.default, _objectSpread({}, components['Claim-1']))
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: `layout2_container_wrapper layout2_container_wrapper--${type}`,
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
                children: [components['SvgIconLoader-1'] && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  className: `container-icon container-icon_color_${segment}--${bgIconColor}`,
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(SvgIconLoader, _objectSpread({}, components['SvgIconLoader-1']))
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  className: `container-prises--${bgPriceColor} container-prises ${components['SvgIconLoader-1'] ? 'container-prises--with-icon' : 'container-prises--without-icon'}`,
                  children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                      className: "container-prises--baseline",
                      children: [components['TextInfo-4'] && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        className: "text-priceBox",
                        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents5.default, _objectSpread(_objectSpread({}, components['TextInfo-4']), {}, {
                          className: "textInfo4"
                        }))
                      }), components['Price-1'] && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        className: "big-price",
                        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, _objectSpread({}, components['Price-1']))
                      })]
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                        className: components['Price-1'] && components['SvgIconLoader-1'] ? 'small-container' : 'wrapper-flex',
                        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                          className: "margin-right",
                          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, _objectSpread({}, components['Price-2']))
                        }), components['TextInfo-6'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents5.default, _objectSpread(_objectSpread({}, components['TextInfo-6']), {}, {
                          className: "small"
                        }))]
                      })
                    })]
                  })
                })]
              })
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: `layout2_button-container layout2_button-container--${type}`,
            id: "show-fixed",
            children: [components['Button-1'] && printButton(components['Button-1']), components['Button-2'] && printButton(components['Button-2'])]
          })]
        })
      })]
    })]
  });
};
Layout2.propTypes = {
  type: _propTypes.default.oneOf([LAYOUT2_TYPE.FUSION, LAYOUT2_TYPE.DISTRIBUTIVA, LAYOUT2_TYPE.DISTRIBUTIVA_TEXTO])
};
Layout2.defaultProps = {
  type: LAYOUT2_TYPE.FUSION
};
var _default = exports.default = Layout2;

//# sourceMappingURL=index.js.map